import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './BasicLoader.module.scss';

const BasicLoader = ({ theme }) => {
  const rootCls = classNames(s.Root, {
    [s.Dark]: theme === 'dark',
  });

  return (
    <div className={rootCls}>
      <div className={s.Loader}></div>
    </div>
  );
};

BasicLoader.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
  animationDuration: PropTypes.number,
};

BasicLoader.defaultProps = {
  theme: 'light',
};

export default BasicLoader;
